import './styles.scss'
import { Skeleton } from 'primereact/skeleton'
import { SKELETON_COUNT } from 'Utils/WeatherUtils/Constants'

const LocationCardSkeletonInner = () => (
  <div className="location-card-skeleton">
    <div className="location-card-header-skeleton">
      <div className="location-date-time-skeleton">
        <Skeleton width="80px" height="18px" className="skeleton-text custom-skelton" />
        <Skeleton width="60px" height="18px" className="skeleton-text custom-skelton" />
      </div>
      <div className="location-flag-wrapper">
        <Skeleton width="60px" height="18px" className="skeleton-text custom-skelton" />
      </div>
      <div className="location-temp-skeleton">
        <Skeleton width="80px" height="48px" className="skeleton-temp custom-skelton" />
      </div>
    </div>
    <div className="location-card-body-skeleton">
      <Skeleton width="150px" height="18px" className="skeleton-text custom-skelton" />
      <Skeleton width="100px" height="16px" className="skeleton-text custom-skelton" />
    </div>
    <div className="location-card-footer-skeleton">
      <Skeleton width="100px" height="16px" className="skeleton-text custom-skelton" />
      <Skeleton width="80px" height="18px" className="skeleton-text custom-skelton" />
    </div>
  </div>
)

const ForecastItemSkeleton = () => (
  <>
    <div className="column-header-skeleton">
      <Skeleton width="90%" height="18px" className="skeleton-text custom-skelton" />
    </div>
    {Array.from({ length: SKELETON_COUNT.FORECAST_ITEM }).map((_, index) => (
      <div className="forecast-item-skeleton" key={index}>
        <Skeleton width="50px" height="18px" className="skeleton-text" />
        <div className="forecast-icon-wrapper">
          <Skeleton shape="circle" width="40px" height="40px" className="skeleton-icon" />
          <Skeleton width="20px" height="20px" className="skeleton-per" />
        </div>
        <Skeleton width="100%" height="6px" className="skeleton-bar" />
        <Skeleton width="30px" height="13px" className="skeleton-text" />
      </div>
    ))}
  </>
)

const HourlyForecastSkeleton = () => (
  <>
    <div className="column-header-skeleton">
      <Skeleton width="90%" height="18px" className="skeleton-text custom-skelton" />
    </div>

    {Array.from({ length: SKELETON_COUNT.HOURLY_FORECAST_SECTION }).map((_, index) => (
      <div className="hourly-forecast-section-skeleton" key={index}>
        {Array.from({ length: SKELETON_COUNT.HOURLY_FORECAST_ITEM }).map((_, itemIndex) => (
          <div className=" hour-row-skeleton" key={itemIndex}>
            <div className="hourly-forecast-item-skeleton">
              <Skeleton width="40px" height="12px" className="skeleton-text" />
              <Skeleton shape="circle" width="30px" height="30px" className="skeleton-icon" />
              <Skeleton width="30px" height="14px" className="skeleton-text" />
            </div>
          </div>
        ))}
      </div>
    ))}
  </>
)

const GraphSkeleton = () => (
  <div className="temperature-graph-skeleton">
    <div className="graph-icons-row">
      {Array.from({ length: SKELETON_COUNT.GRAPH_ITEM }).map((_, index) => (
        <Skeleton shape="circle" width="24px" height="24px" key={index} className="skeleton-icon" />
      ))}
    </div>
    <Skeleton width="100%" height="250px" className="skeleton-chart" />
  </div>
)

export { GraphSkeleton, HourlyForecastSkeleton, ForecastItemSkeleton, LocationCardSkeletonInner }
